// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2uVic","empty":"ModalGraph_empty__2lj5Y"};